


































































import menu from "@/store/modules/ApplicationModule/data/menu";
import Vue from "vue";

// Vue components
import AppPage from "@/components/AppPage.vue";
import VFaIcon from "@/components/VFaIcon.vue";

import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import {
    DeviceOnBoardingCommand,
    DeviceOnBoardingResData,
    DeviceOnBoardingResultEnum,
    DeviceOnBoardingResultEnumToLabel,
} from "@/model/communication/device/DeviceOnBoardingCommand";

export default Vue.extend({
    components: { AppPage, VFaIcon },
    data() {
        return {
            DeviceOnBoardingResultEnum,
            loading: false,
            installationName1: "",
            installationName2: "",
            onBoardingResult: null,
            showGenericError: true,
        };
    },
    computed: {
        menuEntry() {
            return menu.find((m) => m.name == "Tools").children.find((c) => c.name == "On Boarding");
        },
        submitButtonDisabled() {
            if (this.loading) return true;
            if (this.installationName1 != this.installationName2) return true;
            if (this.installationName1 == null || this.installationName1.trim().length == 0) return true;
            return false;
        },
    },
    watch: {
        installationName1() {
            this.partialReset();
        },
        installationName2() {
            this.partialReset();
        },
    },
    methods: {
        DeviceOnBoardingResultEnumToLabel,
        partialReset() {
            this.onBoardingResult = null;
            this.showGenericError = false;
        },
        reset() {
            this.loading = false;
            this.installationName1 = "";
            this.installationName2 = "";
            this.onBoardingResult = null;
            this.showGenericError = false;
        },
        async submit() {
            try {
                if (!this.loading) {
                    this.loading = true;
                    this.partialReset();
                    const res: DeviceOnBoardingResData = await new DeviceOnBoardingCommand(this.installationName1).execute();
                    if (res.responseStatus == ApiResponseStatusEnum.Success && res.responseString != "GenericError") this.onBoardingResult = res.onBoardingResult;
                    else this.showGenericError = true;
                    this.loading = false;
                }
            } catch (e) {
                console.log("Something went wrong during DeviceOnBoardingCommand execution: ", e);
                this.loading = false;
            }
        },
    },
    mounted() {
        this.reset();
    },
});
